import { render, staticRenderFns } from "./SurveyPlanFormView.vue?vue&type=template&id=ba2a2a0c&scoped=true&"
import script from "./SurveyPlanFormView.vue?vue&type=script&lang=ts&"
export * from "./SurveyPlanFormView.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPlanFormView.vue?vue&type=style&index=0&id=ba2a2a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2a2a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VLayout})
